import YandexMap from './component'

export default YandexMap
